export const fetchBlogs = async () => {
    const query = `
        query Publication {
            publication(host: "tushar-kandpal.hashnode.dev") {
                posts(first: 10) {
                    edges {
                        node {
                            id
                            title
                            url
                            brief
                            publishedAt
                        }
                    }
                }
            }
        }
    `;

    const data = await fetch("https://gql.hashnode.com", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            query,
        }),
    });

    const result = await data.json();
    return result;
}